var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0336 14.8578C14.9067 13.4775 14.1112 12.7749 14.1112 8.9695C14.1112 5.48472 12.3332 4.2432 10.8698 3.64022C10.6754 3.56029 10.4925 3.37672 10.4332 3.1769C10.1765 2.30252 9.45692 1.53223 8.50035 1.53223C7.54378 1.53223 6.82372 2.30296 6.56966 3.17778C6.51042 3.3798 6.32744 3.56029 6.13306 3.64022C4.66793 4.24407 2.89169 5.4812 2.89169 8.9695C2.88949 12.7749 2.09396 13.4775 0.96714 14.8578C0.500263 15.4296 0.909219 16.2882 1.72581 16.2882H15.2793C16.0915 16.2882 16.4978 15.427 16.0336 14.8578Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3105 16.2883V16.991C11.3105 17.7364 11.0144 18.4513 10.4873 18.9784C9.9602 19.5055 9.2453 19.8017 8.49987 19.8017C7.75444 19.8017 7.03953 19.5055 6.51243 18.9784C5.98533 18.4513 5.68921 17.7364 5.68921 16.991V16.2883",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBell;